<template class="full-height">
  <div class="knowledge-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName"
      @closed="onDialogClosed"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="formData" :label-width="formLabelWidth" :rules="rules">
          <el-form-item label="封面照" :label-width="formLabelWidth">
            <div>
              <span>尺寸:840*480</span>
              <Upload
                ref="uploadRef"
                :accept="'.jpg,.jpeg,.png'"
                :limitText="'圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                :payload="formData"
                :data-obj="fileObj"
                :limit-file-count="1"
                :use-drag="false"
                :action="'TravelSettings/saveKnowledgeArticle'"
                :auto-upload="false"
                :show-file-list="true"
                :btn-txt="'上傳'"
                :before-file-list="
                  formData.fileInfo && formData.fileInfo.length ? formData.fileInfo[0].files : []
                "
              />
            </div>
          </el-form-item>

          <el-form-item :label="'國家'" prop="countryCascader" :label-width="formLabelWidth">
            <el-cascader
              clearable
              v-model="formData.countryCascader"
              :props="{
                multiple: true,
                value: 'id',
              }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item :label="'標題'" prop="title" :label-width="formLabelWidth">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>

          <el-form-item :label="'連結'" prop="externalUrl" :label-width="formLabelWidth">
            <el-input v-model="formData.externalUrl"></el-input>
          </el-form-item>

          <el-form-item label="內容" :label-width="formLabelWidth" prop="articleContent">
            <div>
              <tinymce ref="tinymce" v-model="formData.articleContent" :height="300" :type="28" />
            </div>
          </el-form-item>

          <el-form-item label="排序" :label-width="formLabelWidth" prop="sort">
            <el-input v-model="formData.sort" autocomplete="off" />
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="saveData">確 定</el-button>

        <el-button type="danger" @click="onDialogClosed()">取 消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="標題查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入標題" />
        </el-form-item>

        <el-form-item label="國家查詢">
          <el-cascader
            clearable
            v-model="listQuery.countryAreaList"
            :props="{
              multiple: true,
              value: 'id',
            }"
            style="width: 100%"
            placeholder="請選擇"
            filterable
            :options="travelAttractionsMenu"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getSearch">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        class="knowledge-list"
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="ID" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="封面照" width="150">
          <template slot-scope="scope">
            <el-image
              style="height: 80px"
              :src="
                scope.row.fileInfo.length > 0
                  ? scope.row.fileInfo[0].files[0].url
                  : 'https://fakeimg.pl/280x160/'
              "
              fit="contain"
              :preview-src-list="fileUrl(scope.row.fileInfo)"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="國家" width="450">
          <template slot-scope="scope">
            <el-input
              :rows="6"
              type="textarea"
              disabled
              :value="showCountry(scope.row.countryCascader)"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column align="center" label="標題" width="150">
          <template slot-scope="scope">
            <!-- <a :href="openUrl + '/' + scope.row.id" target="_blank">
              <span style="color: rgb(64, 158, 255)">{{ scope.row.title }}</span>
            </a> -->
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="連結" width="300">
          <template slot-scope="scope">
            <a
              :href="
                scope.row.externalUrl == '' ? openUrl + '/' + scope.row.id : scope.row.externalUrl
              "
              target="_blank"
            >
              <span style="color: rgb(64, 158, 255)">{{
                scope.row.externalUrl == '' ? openUrl + '/' + scope.row.id : scope.row.externalUrl
              }}</span>
            </a>
            <!-- <span>{{ scope.row.externalUrl }}</span> -->
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" sortable="custom" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" sortable="custom" width="120">
          <template slot-scope="{ row }">
            <span>{{ dataTime(row.buildDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteData(scope.row)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { saveCouponCategory } from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'
import Upload from '@/views/ita/components/fileUpload.vue'
import Tinymce from '@/components/Tinymce'
import { dateFormat } from '@/utils'
import {
  getTravelAttractionsCascaderMenu,
  deleteTravelKnowledge,
  getTravelKnowledgeByID,
  saveTravelKnowledge,
  getTravelKnowledgeAll,
} from '@/api/travel'

var defaultForm = {
  id: null,
  fileInfo: [], //封面照-可多張圖片
  title: '',
  externalUrl: '', //連結
  articleContent: '', //編輯器內容
  country: [],
  countryCascader: [],
  sort: 99,
}

export default {
  name: 'Knowledge',
  components: {
    Pagination,
    Upload,
    Tinymce,
  },
  computed: {
    fileUrl() {
      return function (array) {
        if (array.length) {
          var list = array[0].files.map(x => {
            return x.url
          })
          return list
        } else {
          return ['https://fakeimg.pl/280x160/']
        }
      }
    },
    showCountry() {
      return function (value) {
        var strarray = []
        value.forEach(element => {
          var str = ''
          if (element.length == 3) {
            var firest = this.travelAttractionsMenu.filter(x => {
              return x.id == element[0]
            })
            var sec = firest[0].children.filter(x => {
              return x.id == element[1]
            })
            var three = sec[0].children.filter(x => {
              return x.id == element[2]
            })
            str = firest[0].label + ' / ' + sec[0].label + ' / ' + three[0].label
          } else {
            var firest = this.travelAttractionsMenu.filter(x => {
              return x.id == element[0]
            })
            str = firest[0].label
          }
          strarray.push(str)
        })
        return strarray.join('\n')
      }
    },
    dataTime() {
      return function (value) {
        return dateFormat(value)
      }
    },
  },
  filters: {},
  data() {
    return {
      funcName: '知識',
      dialogTopMargin: '1%',
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formLabelWidth: '120px',
      travelAttractionsMenu: [],
      formData: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        countries: [],
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-BuildDate',
      },
      total: 0,
      list: [],
      rules: {
        countryCascader: [
          {
            type: 'array',
            required: true,
            validator: function (rule, value, callback) {
              if (value.length == 0) {
                callback(new Error('請選擇國家'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        title: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error('請輸入標題'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        externalUrl: [
          {
            required: false,
            validator: function (rule, value, callback) {
              if (value == '' || value == null) {
                callback()
              } else if (!value.includes('https://')) {
                callback(new Error('請輸入正確且安全性的連結'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        sort: [
          {
            required: true,
            message: '請輸入排序',
            trigger: 'blur',
          },
        ],
      },
      openUrl: '',
    }
  },
  async created() {
    this.listLoading = true
    await this.getTravelAttractionsCascaderMenu()
    await this.getList()
    this.openUrl = process.env.VUE_APP_BASE_KNOWLEDGE_ARTICLE
  },
  methods: {
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      this.travelAttractionsMenu = resp.data
    },
    async getSearch() {
      var cascader = this.listQuery.countryAreaList
      if (cascader !== undefined) {
        const country = cascader.flat()
        this.listQuery.countries = [...new Set(country)]
      }
      await this.getList()
    },
    async deleteData(row) {
      if (!confirm(`確定要刪除網卡設定?`)) {
        return
      }
      this.listLoading = true
      try {
        let resp = await deleteTravelKnowledge({ id: row.id })
        await this.getList()
        Message({
          message: `資料處理完成。`,
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
      }
    },
    addData() {
      let vm = this
      vm.formData = JSON.parse(JSON.stringify(defaultForm))
      vm.dialogVisible = true
    },
    async editData(row) {
      this.listLoading = true
      let vm = this
      var res = await getTravelKnowledgeByID(row.id)
      vm.formData = res.data
      this.listLoading = false
      vm.dialogVisible = true
      this.$refs['tinymce'].setValue(vm.formData.articleContent)
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['form'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultForm))
      this.$refs['tinymce'].setValue('') //重置內容
      this.dialogVisible = false
    },
    saveData() {
      if (!confirm(`確定要儲存知識資料?`)) {
        return
      }
      let vm = this
      let refUpload = this.$refs['uploadRef']
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (this.formData.articleContent == '' && this.formData.externalUrl == '') {
            this.$message.error('請輸入內文或連結')
            return false
          }
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            this.$message.error('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          console.log(payload)
          // 編輯既有資料且未重選檔案時，combineFileAndPayload 不會 push fileModel
          // (fileUpload.vue:451)，payload.fileInfo 維持空陣列，直接取 [0] 會 TypeError；
          // 又因位於 validate 的 async callback 內被吞成 unhandled rejection，
          // 畫面上就是「按儲存完全沒反應」。改判斷「新檔或舊檔至少一張」。
          // 另濾除無效的舊檔 ID，避免空值被當成「有舊圖」而誤放行。
          const oldIDs = (payload.fileIDs || []).filter(
            id => id !== undefined && id !== null && id !== ''
          )
          payload.fileIDs = oldIDs
          const hasNewFile = payload.fileInfo && payload.fileInfo.length > 0
          if (!hasNewFile && oldIDs.length === 0) {
            this.$message.error('請上傳文章封面照')
            return false
          }

          vm.dialogLoading = true
          await saveTravelKnowledge(payload)
          await vm.getList()
          vm.dialogVisible = false
          vm.dialogLoading = false
        } else {
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getTravelKnowledgeAll(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.totalItemCount
      this.listLoading = false
    },
  },
}
</script>

<style scoped>
/deep/ .full-height {
  position: relative;
  height: 100%;
}

/deep/ .el-dialog__body {
  padding-top: 0px;
}

/deep/ .networkcard-list .el-input.is-disabled .el-input__inner {
  background-color: #fff6f694;
  border-color: #1256d1;
  color: #0137a3;
  cursor: not-allowed;
}

/deep/ .networkcard-list .el-input__suffix {
  display: none;
}

/deep/:disabled {
  color: blue !important;
}
</style>
